module.exports = __webpack_public_path__ + "img/chat.781879b3.svg";